const BranchDetails = ({ branchDetails }) => {
  let zonename = "";
  if (branchDetails?.zoneDetails?.length)
    zonename = " | " + branchDetails?.zoneDetails[0]?.name;

  return (
    <>
      <div className="px-9 py-5  border-gray-250 border-b w-full ">
        <h2 className="font-semibold text-base mb-3">Branch Detail</h2>
        <div className="flex">
          <img
            src="images/location.png"
            alt="location"
            className="w-[24px] h-[24px] rounded"
          />
          <div className="pl-2">
            <h3 className="text-sm font-semibold">
              {branchDetails?.name} |{" "}
              <span className=" font-normal text-[#222222]">
                {branchDetails?.mobileNo}
              </span>
            </h3>
            <a
              href="#"
              style={{ fontSize: '14px', cursor: 'pointer', textDecoration: 'underline' }}
              onClick={(e) => {
                e.preventDefault(); 
                const latitude = branchDetails?.deliveryMode === 'pickup'
                  ? branchDetails?.lat
                  : branchDetails?.lat;

                const longitude = branchDetails?.deliveryMode === 'pickup'
                  ? branchDetails?.lng
                  : branchDetails?.lng;

                if (latitude && longitude) {
                  const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
                  window.open(mapUrl, '_blank');
                }
              }}
            >
              {branchDetails?.address && (
                <span className="text-sm pt-[4px] text-[#3553e6]">
                  {branchDetails?.address} <strong>{zonename}</strong>
                </span>
              )}
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
export default BranchDetails;
